import { Component, Input } from '@angular/core';
import { GeneratedQrisResponse } from 'src/app/types/response/qrisly.response.type';
import { ModalDownloadQrisComponent } from '../modal-download-qris/modal-download-qris.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  standalone: false,
  selector: 'app-generated-qris',
  templateUrl: './generated-qris.component.html',
  styleUrl: './generated-qris.component.scss'
})
export class GeneratedQrisComponent {
  @Input() data: GeneratedQrisResponse | null = null;
  @Input() isGenerated: boolean = true;

  constructor(
    private message: NzMessageService,
    private modal: NzModalService
  ) {}

  copyQrisCode(qrisString: string) {
    navigator.clipboard.writeText(qrisString);
    this.message.create('success', 'QRIS code copied to clipboard');
  }

  downloadQrCode() {
    this.modal.create({
      nzTitle: undefined,
      nzContent: ModalDownloadQrisComponent,
      nzFooter: null,
      nzCentered: true,
      nzWidth: 500,
      nzData: {
        data: this.data
      },
      nzClosable: false,
    });
  }

  getClassStatus(status: string) {
    switch (status) {
      case 'paid':
        return 'status-success';
      case 'unpaid':
        return 'status-warning';
      default:
        return 'status-default';
    }
  }
}
